module.exports = __webpack_public_path__ + "static/panama-4-a36382ce0cd5ac66d6ccd5f96d1a8f5d.jpg";